import { FormBase } from 'core/components';

export default class OrderingDoctorEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'orderingDoctorId',
                    label: 'Ordering Doctor',
                    placeholder: 'Select Ordering Doctor',
                    rules: 'required'              
                }
            ],
        };
    }
}
